import { useUBL } from '@common/log-manager';
import { parseQueryString } from '@domains/pdp-common';

const commonLog = { navigation: 'product_detail', object_section: 'first_purchase' };

/** @public */
export const useFirstPurchaseDealsUBL = (original_product_id?: string) => {
  const sendUBL = useUBL();

  const savedProductUBL = (
    category: 'save_product' | 'remove_saved_product',
    object_idx: number,
    object_id: string,
  ) => {
    sendUBL({
      ...commonLog,
      category,
      object_type: 'catalog',
      object_id,
      object_idx,
      data: {
        original_product_id,
      },
    });
  };

  const inAppSavedProductUBL = (
    category: 'save_product' | 'remove_saved_product',
    object_idx: number,
    object_id: string,
    log?: string | null,
  ) => {
    return {
      ...commonLog,
      category,
      object_type: 'catalog',
      object_id,
      object_idx,
      data: {
        original_product_id,
        ...(log ? parseQueryString(log) : undefined),
      },
    };
  };

  const productImpressionUBL = (object_id: string, position: number, log?: string | null) => {
    sendUBL({
      ...commonLog,
      category: 'impression',
      object_type: 'catalog',
      object_id,
      object_idx: position,
      data: {
        original_product_id,
        ...(log ? parseQueryString(log) : undefined),
      },
    });
  };

  const productClickUBL = (object_id: string, position: number, log?: string | null) => {
    sendUBL({
      ...commonLog,
      category: 'click',
      object_type: 'catalog',
      object_id,
      object_idx: position,
      data: {
        original_product_id,
        ...(log ? parseQueryString(log) : undefined),
      },
    });
  };

  const moreClickUBL = async () => {
    sendUBL({
      ...commonLog,
      category: 'click',
      object_type: 'button',
      object_id: 'see_all',
    });
  };

  return {
    productImpressionUBL,
    productClickUBL,
    savedProductUBL,
    moreClickUBL,
    inAppSavedProductUBL,
  };
};
